import SauvegardeManager from "../../SauvegardeManager";
import ChiffreCode from "./ChiffreCode";

export default class Ordi extends Phaser.GameObjects.Container {
    constructor(scene, x, y) {
        super(scene, x, y, []);

        this.soundManager = scene.soundManager

        this.scene = scene;
        scene.add.existing(this);

        // Gestion de la progression
        this.sauvegardeManager = new SauvegardeManager()
        this.progression = this.sauvegardeManager.getChapitreProgression("Chapitre1")["ordi"];
        this.config = this.scene.cache.json.get('config')['Chapitre1']['ordi']

        // Ajout fond ordi
        this.background = this.scene.add.image(0, 0, 'Chapitre1_ordi_background').setOrigin(0.5, 0);
        this.background.setInteractive();
        this.add(this.background);

        // Ajout article linkedin
        let article = this.scene.add.image(190, this.background.height - 86, 'Chapitre1_ordi_article_linkedin').setOrigin(0.5, 1);
        this.add(article);

        // Ajout liens externes (google, wikipedia, etc)
        this.icons = []
        this.addIcons()

        this.setSize(this.background.width, this.background.height);

        // Ajout code si ordi locked
        if(this.progression.locked){
            this.lockButtons();
            this.setLocked()
        }
    }

    animIn(endFunc){
        let audi = 'OrdiLocked'
        if(!this.progression.locked){
            audi = 'OrdiUnlocked'
        }
        this.soundManager.playOnce(audi)
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            y: this.scene.height - this.height,
            duration: 300,
            onComplete: () => {
                if(endFunc)
                    endFunc();
            }
        });
    }

    animOut(endFunc){
        this.soundManager.playOnce('OrdiClosed')
        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            y: this.y + 200,
            duration: 300,
            onComplete: () => {
                if(endFunc)
                    endFunc();
            }
        });
    }

    // Block
    lockButtons(){
        this.icons.forEach( button => {
            button.disableInteractive();
        })
    }

    unlockButtons(){
        this.icons.forEach( button => {
            button.setInteractive({useHandCursor: true});
        })
    }

    isLocked() {
        return this.progression.locked;
    }

    setLocked(){
        this.lockedContainer = this.scene.add.container(0, 0, [])
        this.add(this.lockedContainer);

        // Modif du fond
        this.backgroundLocked = this.scene.add.image(0, 0, 'Chapitre1_ordi_code').setOrigin(0.5, 0);
        this.backgroundLocked.setInteractive();
        this.lockedContainer.add(this.backgroundLocked);

        // Ajout du code à rentrer
        this.chiffre1 = new ChiffreCode(this.scene, -264, 500, () => {
            this.checkCode();
        })
        this.lockedContainer.add(this.chiffre1);

        this.chiffre2 = new ChiffreCode(this.scene, 0, 500, () => {
            this.checkCode();
        })
        this.lockedContainer.add(this.chiffre2);

        this.chiffre3 = new ChiffreCode(this.scene, 264, 500, () => {
            this.checkCode();
        })
        this.lockedContainer.add(this.chiffre3);
    }

    // -- Code à rentrer
    checkCode(){
        if(
            this.chiffre1.getValue() == 3 &&
            this.chiffre2.getValue() == 1 &&
            this.chiffre3.getValue() == 5
        ){
            this.scene.closePopupOrdi();
            this.chiffre1.hidebuttons();
            this.chiffre2.hidebuttons();
            this.chiffre3.hidebuttons();
            this.setUnlocked();
        }
    }

    setUnlocked(){
        // Update progression
        this.progression.locked = false;

        this.soundManager.playOnce('OrdiUnlocked')

        // Anim out
        this.scene.tweens.add({
            targets: this.lockedContainer,
            alpha: 0,
            duration: 500,
            onComplete: () => {
                this.lockedContainer.destroy(true);
                this.lockedContainer = null;

                this.scene.popupStart()
            }
        });

    }

    // Ajout liens externes sur le bureau de l'ordi
    addIcons(){
        const deltaY = 130

        Object.keys(this.config.liens).forEach( (icon, index) => {
            let iconElmt = this.scene.add.image(700, 180 + index * deltaY, icon).setOrigin(0.5);
            this.add(iconElmt)
            this.icons.push(iconElmt);

            iconElmt.setInteractive({useHandCursor: true})
            iconElmt.on('pointerup', () => {
                this.scene.tweens.add({
                    targets: iconElmt,
                    scale: 0.9,
                    duration: 100,
                    yoyo: true,
                    ease: 'Cubic.easeInOut',
                    onComplete: () => {
                        window.open(this.config.liens[icon], '_blank');
                    }
                })
            })
        })
    }
}